import {
  formatDecimal,
  getDecimalSign,
  getDisplayDecimals,
} from './format-decimal';

export const clampNonNegative = (value: number | string): number => {
  const num = Number(value);
  if (Number.isNaN(num) || num < 0) {
    return 0;
  }
  return num;
};

export { getDisplayDecimals as getCryptoAmountDecimals } from './format-decimal';

const toAmountString = (value: number | string): string | null => {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      return null;
    }
    return String(value);
  }

  const trimmed = value.trim();
  return trimmed || null;
};

export const formatAmount = (value: number | string, decimals = 4, grouping = false): string => {
  const amount = toAmountString(value);
  if (amount == null) {
    return formatDecimal('0', { decimals, grouping, trimTrailingZeros: false });
  }

  const formatted = formatDecimal(amount, {
    decimals,
    grouping,
    trimTrailingZeros: false,
    emptyLabel: '',
  });

  if (!formatted) {
    return formatDecimal('0', { decimals, grouping, trimTrailingZeros: false });
  }

  return formatted;
};

export const formatCryptoAmount = (
  value: number | string,
  currencyCode?: string | null,
  grouping = false,
): string => formatAmount(value, getDisplayDecimals(currencyCode), grouping);

export const formatSignedAmount = (value: number | string, decimals = 4): string => {
  const amount = toAmountString(value);
  if (amount == null) {
    return formatAmount(0, decimals);
  }

  const sign = getDecimalSign(amount);
  const unsigned = amount.startsWith('-') ? amount.slice(1) : amount;
  const formatted = formatAmount(unsigned, decimals);

  if (sign === 'positive') {
    return `+${formatted}`;
  }
  if (sign === 'negative') {
    return `-${formatted}`;
  }
  return formatted;
};
